import { api } from "../Api";
import i18n from "../../Config/i18n.js";
export class ControlService {
    
    // Enviar o código de autenticação
    async sendAuthCode (code : string,):Promise<any>{
        try {
            const response = await api.post('/VerifyCode', {'codigo': code});
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw new Error(error.response?.data?.message? error.response.data.message : i18n.t('request-errors.unauthenticated'));
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Envia a mensagem com os comandos
    async sendMessage (pocoID: string, comands: Array<string|number>): Promise<any>{
        try {
            const response = await api.post('/Pocos/controle/sendMessageIoT',
                {
                    'poco': pocoID,
                    'comandos': comands,
                }
            );
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega os poços que o usuário tem acesso
    async getPocosByUser(): Promise<any>{
        try {
            const pocos = await api.get(`/me/authorizedEquipmentsCommandsInterface`);
            return pocos.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega o layout ativo do usuário para o poço
    async getActiveLayout(poco: string): Promise<any>{
        try {
            const ActiveLayout = await api.get(`/Interface/ativo/${poco}`);
            // const ActiveLayout = await api.get(`/Interface/padrao/${poco}`);
            return ActiveLayout.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega o layout ativo do usuário para o poço
    async getDefautLayout(poco: string): Promise<any>{
        try {
            const DefautLayout = await api.get(`/Interface/padrao/${poco}`);
            return DefautLayout.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Pega o layout ativo do usuário para o poço
    async getLayout(poco: string, layout: string): Promise<any>{
        try {
            const currentLayout = await api.get(`/Interface/layout/${poco}/${layout}`);
            return currentLayout.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // Lista todos layouts do usuário
    async listLayouts (equipamento: string): Promise<any>{
        try {
            const layoutsList = await api.get(`/Interface/menu/${equipamento}`);
            return layoutsList.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // enviar o layout editado
    async editLayout (idLayout:string, layout: Array<Object>, columnsOut:Array<string>, nameLayout:string, equipamento:string): Promise<any>{
        try {
            const layoutsList = await api.post(`/Interface/editLayout`,
            {
                'equipamento': equipamento,
                'layout_id': idLayout,
                'layout_name': nameLayout,
                'new_layout': layout,
                'columns_out': columnsOut,
                'active': true,
            }
            );
            return layoutsList.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    // enviar o layout editado
    async deleteLayout (idLayout:string): Promise<any>{
        try {
            const response = await api.delete(`/Layouts/${idLayout}`);
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async getGraphData(poco:string, variavel:string, time: number): Promise<any>{
        try {
            const data = await api.get(`/Interface/mediasDetalhes/${poco}/${variavel}/${time}`);
            return data.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                if(error.response?.data?.message){throw new Error(error.response.data.message)}
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

    async RequestCities():Promise<any>{
        try {
            const response = await api.get('/me/authorizedCitiesCommandsInterface');
            return response.data;
        } catch (error: any) {
            if(error.response?.status === 401){
                throw Object.assign(new Error(i18n.t('request-errors.unauthenticated')), { status: 401 });
            }else if (error.response && error.response.data && error.response.data.message) {
                const errorMessage = error.response.data.message;
                throw new Error(errorMessage);
            } else {
                throw new Error(i18n.t('request-errors.server-connection'));
            }
        }
    }

}

export const controlService = new ControlService();